import React from 'react'

import {
  Well,
  WellLabel,
  RosterItemWrapper,
  RosterItemThumb,
  RosterItemName,
  // RosterItemMeta,
} from '../../styles'

const Roster = ({players}) => (
  <Well>
    <WellLabel>Players</WellLabel>
    {players.map(p => (
      <RosterItemWrapper key={p.id} alive={p.alive}>
        <RosterItemThumb>{p.thumb}</RosterItemThumb>
        <div>
          <RosterItemName alive={p.alive}>{p.name}</RosterItemName>
          {/*
            <RosterItemMeta>{p.alive ? `` : `killed with word "${p.poisonWord}"`}</RosterItemMeta>
          */}
        </div>
      </RosterItemWrapper>
    ))}
  </Well>
)

export default Roster



// WEBPACK FOOTER //
// ./src/views/game/components/Roster.jsx